import { SVGAttributes } from "react";

export const UnderlineIcon = (
  props: SVGAttributes<SVGElement> & { size: "small" | "regular" }
) => {
  if (props.size === "small") {
    return (
      <svg
        width={16}
        height={16}
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <path
          d="M3 2a1 1 0 012 0v6c0 .195.084.573.332.945C5.766 9.595 6.575 10 8 10s2.235-.405 2.668-1.055c.248-.372.332-.75.332-.945V2a1 1 0 112 0v6c0 .555-.166 1.302-.668 2.055C11.515 11.28 10.074 12 8 12c-2.075 0-3.516-.72-4.332-1.945C3.166 9.302 3 8.555 3 8V2z"
          fill="currentColor"
        />
        <path
          d="M3 3a1 1 0 010-2h2a1 1 0 010 2H3zM11 3a1 1 0 110-2h2a1 1 0 110 2h-2zM3 15a1 1 0 110-2h10a1 1 0 110 2H3z"
          fill="currentColor"
        />
      </svg>
    );
  } else {
    return (
      <svg
        width={24}
        height={24}
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M5 6a1 1 0 011-1h2a1 1 0 010 2v5c0 3.484 1.263 5 4 5s4-1.516 4-5V7a1 1 0 110-2h2a1 1 0 110 2v5c0 4.516-2.07 7-6 7s-6-2.484-6-7V7a1 1 0 01-1-1zM4 20a1 1 0 100 2h16a1 1 0 100-2H4z"
          fill="currentColor"
        />
      </svg>
    );
  }
};
UnderlineIcon.displayName = "UnderlineIcon";
